import { productCodeMap } from '@/utils/document/product-code-map';

const path = '/img/products/onvideo';
const docConfig = { name: '产品文档', link: productCodeMap.ON_VIDEO };
export const BANNER_DATA = {
  title: '快手云剪',
  backgroundImg: `${path}/banner.webp`,
  backgroundImgMobile: `${path}/banner-mobile.webp`,
  description:
    '快手云剪是一款在线视频协同创作工具，提供正版授权素材、云端视频剪辑、直播剪辑、云端媒体资产管理、多人协作、多款智能AI创作工具、一键发布快手等一站式云端视频创作能力，帮助用户、企业提升内容创作效率',
  buttonText: '立即体验',
  buttonLink: 'https://onvideo.kuaishou.com/',
  // mobileExtraButton: { ...docConfig},
  links: [
    // { name: 'Demo体验', link: '' },
    // { ...docConfig },
    // { name: '管理控制台', link: '' },
  ],
};
export const ADVANTAGES_EFFECT = [
  {
    title: '丰富的视频创作工具',
    content:
      '提供专业级的web视频编辑、直播拆条、文字转视频以及多款AI处理工具，满足各类创作需求',
    picUrl: `${path}/icon1.webp`,
  },
  {
    title: '高效的智能辅助创作',
    content: '多项AI能力及智能小工具赋能视频创作，大幅提升视频创作的效率',
    picUrl: `${path}/icon2.webp`,
  },
  {
    title: '丰富的云端版权内容',
    content: '提供视频、图片、音乐、音效、字体、贴纸等丰富的版权素材',
    picUrl: `${path}/icon3.webp`,
  },
  {
    title: '便捷的云端管理和协作',
    content: '即开即用，多个成员随时随地协同创作，云端媒资安全存储、共享、管理',
    picUrl: `${path}/icon4.webp`,
  },
];

export const FEATURES = [
  {
    title: '视频剪辑',
    content:
      '无需下载，打开浏览器即可创作，支持多轨、帧精确、画中画、帧定格、一键抠像等专业级剪辑能力',
    picUrl: `${path}/3D-icon1.webp`,
  },
  {
    title: '直播剪辑',
    content: '支持边直播边实时剪辑，语音、高光时刻等多种智能辅助定位',
    picUrl: `${path}/3D-icon2.webp`,
  },
  {
    title: '协同与管理',
    content:
      '支持云端多人协作，提供共享存储空间，支持人员管理、媒体资产共享，支持识别媒资中人脸、语音等',
    picUrl: `${path}/3D-icon3.webp`,
  },
  {
    title: 'AI工具库',
    content:
      '智能字幕、智能配音、横转竖、智能封面、数据视频、画质增强、智能增稳等多款易用工具',
    picUrl: `${path}/3D-icon4.webp`,
  },
];

export const SCENARIO_EFFECT = [
  {
    title: '广电传媒机构',
    content:
      '快手云剪可为广电提供一站式短视频内容采集、制作、媒资管理、流程管理、发布管理等能力，并且支持灵活的部署方式',
    picUrl: `${path}/scenario1.webp`,
    picHoverUrl: `${path}/scenario1-hover.webp`,
  },
  {
    title: '短视频制作团队',
    content:
      '快手云剪支持多人协同创作、媒体资产共享管理，通过平台提供的视频编辑器、直播剪辑工具以及多款智能工具，可大幅提升协同创作和管理的效率',
    picUrl: `${path}/scenario2.webp`,
    picHoverUrl: `${path}/scenario2-hover.webp`,
  },
  {
    title: '企业营销视频',
    content:
      '基于丰富的版权视频、图片、音乐音效以及完善、专业的云端制作工具和管理流程，企业或广告代理机构，快速制作视频。并且可通过定制不同模板进行批量化广告视频生产',
    picUrl: `${path}/scenario3.webp`,
    picHoverUrl: `${path}/scenario3-hover.webp`,
  },
];

export const ARCHITECTURE = {
  title: '产品架构',
  picUrl: `${path}/architecture.webp`,
};

export const BEST_PRACTICE = {
  title: '最佳实践',
  items: [
    {
      title: '东京奥运会',
      subTitle:
        '东京奥运会，快手云剪全面投入视频内容生产中，实现云上异地协同内容制作，在降低硬件和人力成本的同时，打造了更为丰富的内容生产模式。\n通过快手云剪云上内容生产中心，分布在全国各地的内容制作团队在云端进行协作式内容生产、管理及分发，有力地应对了奥运项目时间跨度长、内容生产量大的挑战。在持续17天赛期内，通过快手云剪，内容制作团队共创作生产了超过1万个视频作品，创造了高达百亿级别的播放量',
      picUrl: `${path}/use-case1.webp`,
    },
    {
      title: '北京冬奥会',
      subTitle:
        '2022年北京冬季奥运会，快手云剪作为快手云上内容生产中心，赛事内容制作团队通过云上异地协同内容制作，前后持续18天，共产出近2万条冬奥赛事视频作品，共产生近50亿播放量，快手云剪无故障高稳定运行，非常好的保障了快手冬奥赛事内容的产量和时效。',
      picUrl: `${path}/use-case2.webp`,
    },
  ],

  picUrl: `/img/solutions/entertainment/peitu.webp`,
};
export const BRAND = {
  title: '客户案例',
  items: ['快手', 'AcFun'],
};
